import React from 'react';

import StandardModal from '../../Shared/UI/StandardModal/components/StandardModal';
import PageTitle from '../../Shared/UI/PageTitle/components/PageTitle';
import CloseJobDescriptionFromExternalWebsiteForm from './CloseJobDescriptionFromExternalWebsiteForm';

import { useJobDescriptionsFromExternalWebsitesState, useJobDescriptionsFromExternalWebsitesActions } from './JobDescriptionsFromExternalWebsitesContext';

const CloseJobDescriptionFromExternalWebsiteModal = () => {
  const jobDescriptionsFromExternalWebsitesState = useJobDescriptionsFromExternalWebsitesState();
  const { closeCloseJobDescriptionFromExternalWebsiteModal } = useJobDescriptionsFromExternalWebsitesActions();

  return (
    <StandardModal
      isOpen={jobDescriptionsFromExternalWebsitesState?.closeJobDescriptionFromExternalWebsiteModalIsOpen}
      contentLabel={'Close Job Description from External Website'}
      onRequestClose={() => {
        closeCloseJobDescriptionFromExternalWebsiteModal();
      }}
    >
      <CloseJobDescriptionFromExternalWebsiteForm />
    </StandardModal>
  );
};

export default CloseJobDescriptionFromExternalWebsiteModal;